import { PermissionTableRowType } from '../../../../../../types/common/PermissionType';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../../../constants/service/common/userPermissions';
/*
생성/등록/추가 : create
삭제/제거 : delete
편집/수정 : update
상세페이지/보기 : read
리스트/보기 : readList
엑셀다운로드 : downloadExcel
*/
export const PAYMENT_MENU: PermissionTableRowType = {
  name: '결제',
  key: 'PAYMENT_MANAGE',
  subRows: [
    {
      name: '결제 설정',
      key: PERMISSION_SUBJECTS.PAYMENT_PG_ROUTE,
      permissions: [PERMISSION_ACTIONS.READ, PERMISSION_ACTIONS.UPDATE],
      subRows: [
        {
          name: '규칙 조회',
          key: PERMISSION_SUBJECTS.PAYMENT_PG_ROUTE,
          permissions: [PERMISSION_ACTIONS.READ],
        },
        {
          name: '규칙 저장',
          key: PERMISSION_SUBJECTS.PAYMENT_PG_ROUTE,
          permissions: [PERMISSION_ACTIONS.UPDATE],
        },
      ],
    },
    {
      // 정산금·손익에 닿는 값이라 결제 설정과 권한을 나눈다.
      name: 'PG 수수료 관리',
      key: PERMISSION_SUBJECTS.PAYMENT_PG_FEE,
      permissions: [PERMISSION_ACTIONS.READ, PERMISSION_ACTIONS.UPDATE],
      subRows: [
        {
          name: '수수료 조회',
          key: PERMISSION_SUBJECTS.PAYMENT_PG_FEE,
          permissions: [PERMISSION_ACTIONS.READ],
        },
        {
          name: '수수료 저장',
          key: PERMISSION_SUBJECTS.PAYMENT_PG_FEE,
          permissions: [PERMISSION_ACTIONS.UPDATE],
        },
      ],
    },
  ],
};
